(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["browsing-history"] && !Shopify.designMode) return;
  try {
    
(() => {
  // ------- utils -------
  const onReady = (fn) => {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn, { once:true }); }
    else { fn(); }
  };

  const gidToNumeric = (id) => {
    if (!id) return id;
    const m = String(id).match(/\/(\d+)$|^(\d+)$/);
    return m ? (m[1] || m[2]) : id;
  };

  const uniq = (arr) => {
    const s = new Set();
    return arr.filter((v) => { const k = String(v); if (s.has(k)) return false; s.add(k); return true; });
  };

  // Prefer the theme’s RecentlyViewed API if present; else your asset's storage key.
  const getRecentlyViewedIds = () => {
    const api = (window.RecentlyViewed) || (window.Theme && window.Theme.RecentlyViewed);
    if (api && typeof api.getAllProducts === 'function') {
      try { return api.getAllProducts() || []; } catch { /* noop */ }
    }
    try {
      const raw = localStorage.getItem('allViewedProducts'); // ← your asset’s STORAGE_KEY
      const ids = raw ? JSON.parse(raw) : [];
      return Array.isArray(ids) ? ids : [];
    } catch { return []; }
  };

  // Prefer predictive_search_url → search_url → fallback to /search/suggest
  const buildSearchUrl = (ids) => {
    const routes = window.Theme && window.Theme.routes;
    const base = (routes && (routes.predictive_search_url || routes.search_url)) || '/search/suggest';
    const url = new URL(base, location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit_scope]', 'each');
    return url;
  };

  // Fetch HTML using sectionRenderer if present; otherwise, use Section Rendering API fallbacks.
  const fetchSectionHTML = async (sectionId, url) => {
    if (window.sectionRenderer && typeof window.sectionRenderer.getSectionHTML === 'function') {
      try { return await window.sectionRenderer.getSectionHTML(sectionId, false, url); }
      catch { /* noop */ }
    }
    try {
      const u1 = new URL(url);
      u1.searchParams.set('sections', sectionId);
      const r1 = await fetch(u1.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const t1 = await r1.text();
      try {
        const j = JSON.parse(t1);
        if (j && j[sectionId]) return j[sectionId];
      } catch { if (t1) return t1; }
    } catch { /* noop */ }

    try {
      const u2 = new URL(url);
      u2.searchParams.set('section_id', sectionId);
      const r2 = await fetch(u2.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const t2 = await r2.text();
      if (t2) return t2;
    } catch { /* noop */ }

    return '';
  };

  const renderCards = async ({ ids, root, gridSel, emptySel }) => {
    const grid  = root.querySelector(gridSel);
    const empty = root.querySelector(emptySel);
    const sectionId = root.dataset.rendererSectionId || '';
    const productsContainerId = root.dataset.productsSectionId || 'predictive-search-products';

    if (!grid) return;
    if (!ids.length) { if (empty) empty.hidden = false; grid.innerHTML = ''; return; }
    if (!sectionId)  { if (empty) empty.hidden = false; return; }

    const url = buildSearchUrl(ids);

    try {
      const html = await fetchSectionHTML(sectionId, url);
      if (!html) { if (empty) empty.hidden = false; return; }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const container = doc.getElementById(productsContainerId);
      if (!container) { if (empty) empty.hidden = false; grid.innerHTML = ''; return; }

      // Only take the product cards, not the predictive header.
      const list = container.querySelector('.predictive-search-results__wrapper-products');
      const cards = list
        ? Array.from(list.querySelectorAll('.predictive-search-results__card'))
        : Array.from(container.querySelectorAll('.predictive-search-results__card')); // fallback

      grid.innerHTML = '';
      if (cards.length) {
        // Wrap each predictive card in a product-list item
        cards.forEach((card) => {
          const item = document.createElement('div');
          item.className = 'resource-list__item';
          item.appendChild(card);
          grid.appendChild(item);
        });
        if (empty) empty.hidden = true;
      } else {
        if (empty) empty.hidden = false;
      }
    } catch {
      if (empty) empty.hidden = false;
    }
  };

  const initOne = async (root) => {
    const renderRecentlyViewed = async () => {
      let ids = getRecentlyViewedIds();
      ids = uniq(ids.map(gidToNumeric)).filter(Boolean);
      await renderCards({ ids, root, gridSel: '[data-rv-grid]', emptySel: '[data-rv-empty]' });
    };

    const renderRecentPurchases = async () => {
      const idsStr = root.dataset.recentPurchaseIds || '';
      let ids = idsStr ? idsStr.split(',').map(gidToNumeric) : [];
      ids = uniq(ids).filter(Boolean);
      await renderCards({ ids, root, gridSel: '[data-rp-grid]', emptySel: '[data-rp-empty]' });
    };

    // Clear button (works even if no global RecentlyViewed is exposed)
    const clearBtn = root.querySelector('[data-clear-recently-viewed]');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        try {
          if (window.RecentlyViewed && typeof window.RecentlyViewed.clearProducts === 'function') {
            window.RecentlyViewed.clearProducts();
          } else {
            localStorage.removeItem('viewedProducts');
          }
        } catch {}
        const rvGrid = root.querySelector('[data-rv-grid]');
        if (rvGrid) rvGrid.innerHTML = '';
        const empty = root.querySelector('[data-rv-empty]');
        if (empty) empty.hidden = false;
      });
    }

    await Promise.all([renderRecentlyViewed(), renderRecentPurchases()]);
  };

  onReady(() => {
    const roots = document.querySelectorAll('[data-browsing-history]');
    if (!roots.length) return;
    roots.forEach(initOne);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-dynamic-ids"] && !Shopify.designMode) return;
  try {
    
(() => {
  const onReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  };

  const gidToNumeric = (id) => {
    if (!id) return id;
    const m = String(id).match(/\/(\d+)$|^(\d+)$/);
    return m ? (m[1] || m[2]) : id;
  };
  const uniq = (arr) => {
    const s = new Set();
    return arr.filter((v) => { const k = String(v); if (s.has(k)) return false; s.add(k); return true; });
  };

  const parseExplicitIds = (raw) => {
    if (!raw) return [];
    try {
      // JSON array?
      const j = JSON.parse(raw);
      if (Array.isArray(j)) return j;
    } catch {}
    // CSV fallback
    return String(raw).split(',').map((s) => s.trim()).filter(Boolean);
  };

  // Prefer Theme.RecentlyViewed, otherwise localStorage[storage_key]
  const getRecentlyViewedIds = (storageKey) => {
    const api = (window.RecentlyViewed) || (window.Theme && window.Theme.RecentlyViewed);
    if (api && typeof api.getAllProducts === 'function') {
      try { return api.getAllProducts() || []; } catch {}
    }
    try {
      const raw = localStorage.getItem(storageKey || 'allViewedProducts');
      const ids = raw ? JSON.parse(raw) : [];
      return Array.isArray(ids) ? ids : [];
    } catch { return []; }
  };

  const buildSearchUrl = (ids) => {
    // Prefer predictive_search_url → search_url → /search/suggest
    const routes = window.Theme && window.Theme.routes;
    const base = (routes && (routes.predictive_search_url || routes.search_url)) || '/search/suggest';
    const url = new URL(base, location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit_scope]', 'each');
    return url;
  };

  // Section rendering helper with graceful fallbacks
  const fetchSectionHTML = async (sectionId, url) => {
    if (window.sectionRenderer && typeof window.sectionRenderer.getSectionHTML === 'function') {
      try { return await window.sectionRenderer.getSectionHTML(sectionId, false, url); }
      catch { /* noop */ }
    }
    try {
      const u1 = new URL(url);
      u1.searchParams.set('sections', sectionId);
      const r1 = await fetch(u1.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const t1 = await r1.text();
      try {
        const j = JSON.parse(t1);
        if (j && j[sectionId]) return j[sectionId];
      } catch { if (t1) return t1; }
    } catch { /* noop */ }

    try {
      const u2 = new URL(url);
      u2.searchParams.set('section_id', sectionId);
      const r2 = await fetch(u2.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const t2 = await r2.text();
      if (t2) return t2;
    } catch { /* noop */ }

    return '';
  };

  const renderCards = async ({ ids, root, gridEl, emptyEl }) => {
    const sectionId = root.dataset.rendererSectionId || 'predictive-search';
    const productsContainerId = root.dataset.productsSectionId || 'predictive-search-products';

    if (!ids.length) {
      gridEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    const url = buildSearchUrl(ids);
    try {
      const html = await fetchSectionHTML(sectionId, url);
      if (!html) { if (emptyEl) emptyEl.hidden = false; gridEl.innerHTML = ''; return; }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const container = doc.getElementById(productsContainerId);
      if (!container) { if (emptyEl) emptyEl.hidden = false; gridEl.innerHTML = ''; return; }

      const list = container.querySelector('.predictive-search-results__wrapper-products');
      const cards = list
        ? Array.from(list.querySelectorAll('.predictive-search-results__card'))
        : Array.from(container.querySelectorAll('.predictive-search-results__card'));

      gridEl.innerHTML = '';
      if (cards.length) {
        cards.forEach((card) => {
          const item = document.createElement('div');
          item.className = 'resource-list__item';
          item.appendChild(card);
          gridEl.appendChild(item);
        });
        if (emptyEl) emptyEl.hidden = true;
      } else {
        if (emptyEl) emptyEl.hidden = false;
      }
    } catch {
      if (emptyEl) emptyEl.hidden = false;
    }
  };

  const initOne = (root) => {
    const gridEl  = root.querySelector('[data-dpl-grid]');
    const emptyEl = root.querySelector('[data-dpl-empty]');
    const pagerEl = root.querySelector('[data-dpl-pager]');
    const prevBtn = root.querySelector('[data-dpl-prev]');
    const nextBtn = root.querySelector('[data-dpl-next]');
    const status  = root.querySelector('[data-dpl-status]');

    const itemsPerPage = Math.max(1, parseInt(root.dataset.itemsPerPage || '8', 10));
    const reverse = root.dataset.reverse === 'true';

    let allIds = [];
    let page = 1;

    const getIdsFromSource = () => {
      const source = root.dataset.source;
      if (source === 'explicit_ids') {
        return parseExplicitIds(root.dataset.explicitIds);
      } else {
        const sk = root.dataset.storageKey || 'allViewedProducts';
        return getRecentlyViewedIds(sk);
      }
    };

    const normalizeIds = (raw) => {
      let ids = (raw || []).map(gidToNumeric).filter(Boolean);
      if (reverse) ids = ids.slice().reverse();
      // Deduplicate but preserve order
      const seen = new Set();
      ids = ids.filter((id) => (seen.has(id) ? false : (seen.add(id), true)));
      return ids;
    };

    const totalPages = () => Math.max(1, Math.ceil(allIds.length / itemsPerPage));

    const sliceForPage = (p) => {
      const start = (p - 1) * itemsPerPage;
      return allIds.slice(start, start + itemsPerPage);
    };

    const updatePager = () => {
      const tp = totalPages();
      pagerEl.hidden = tp <= 1;
      if (status) status.textContent = `Page ${page}${tp > 1 ? ` of ${tp}` : ''}`;
      if (prevBtn) prevBtn.disabled = (page <= 1);
      if (nextBtn) nextBtn.disabled = (page >= tp);
    };

    const doRender = async () => {
      const ids = sliceForPage(page);
      await renderCards({ ids, root, gridEl, emptyEl });
      updatePager();
    };

    const refresh = async () => {
      const raw = getIdsFromSource();
      allIds = normalizeIds(raw);
      page = 1;
      await doRender();
    };

    // Clear (only for Recently viewed)
    const clearBtn = root.querySelector('[data-dpl-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        try {
          if (window.RecentlyViewed && typeof window.RecentlyViewed.clearProducts === 'function') {
            window.RecentlyViewed.clearProducts();
          } else {
            const sk = root.dataset.storageKey || 'allViewedProducts';
            localStorage.removeItem(sk);
          }
        } catch {}
        refresh();
      });
    }

    // Pager handlers
    if (prevBtn) prevBtn.addEventListener('click', async () => { if (page > 1) { page--; await doRender(); }});
    if (nextBtn) nextBtn.addEventListener('click', async () => { if (page < totalPages()) { page++; await doRender(); }});

    // External hooks
    window.addEventListener('dynamicProductList:setIds', async (e) => {
      const { ids, sectionId } = e.detail || {};
      if (sectionId && sectionId !== root.id) return;
      allIds = normalizeIds(ids || []);
      page = 1;
      await doRender();
    });

    window.addEventListener('dynamicProductList:refresh', async (e) => {
      const { sectionId } = e.detail || {};
      if (sectionId && sectionId !== root.id) return;
      await refresh();
    });

    // Initial render
    refresh();
  };

  onReady(() => {
    document.querySelectorAll('[data-dpl]').forEach(initOne);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
